import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { NoteSchema } from '../../../services/formValidator/userValidator';
import useEncryption from '../../../services/useEncryption';
import { updateNotesApi } from '../../../api/userApi/userApi';
import useHeaders from '../../../helpers/useHeaders';
import useToast from '../../../helpers/useToast';
import { toast } from "react-toastify";
import "./allpages.css";
import { useOutletContext } from 'react-router-dom';
import { createAuditLogs } from '../../../api/providerApi/providerApi';
import { useSelector } from 'react-redux';
import { selectAuth } from '../../../redux/slice/authSlice';

const UpdateNotesModal = ({ isEditOpen , handleEditClose , selectedNote}) => {
    const { encryptData, decryptData } = useEncryption();
    const headers = useHeaders();
    const toastOptions = useToast();
    const { role } = useSelector(selectAuth);

  const formik = useFormik({
    initialValues: {
      notes: '',  
    },
    validationSchema: NoteSchema,
    onSubmit: async (values, { resetForm }) => {
      
    try {
      const id =  selectedNote?._id;
        const data = encryptData(values);
        const response = await updateNotesApi(id, data, headers); 
        let obj = {
          event : `${role == 'doctor' ? 'Doctor' : 'SuperAdmin'} has updated the Note for lead.`
        }
        await createAuditLogs({ data: encryptData(obj)}, headers);
        toast.success(response.data.message,toastOptions);
        handleCancel();
    } catch (error) {
        toast.error(error.response.data.message, toastOptions);
    }
    },
  });

  useEffect(() => {
    if (selectedNote) {
        formik.setValues({
            notes: selectedNote.notes || '', 
        });
    }
}, [selectedNote]);

const handleCancel = () => {
    formik.resetForm();
    handleEditClose();
};

  return (
    <Dialog
      onClose={handleEditClose}
      aria-labelledby="customized-dialog-title"
      open={isEditOpen}
    >
      <div className="d-flex align-items-center justify-content-between">
        <DialogTitle id="customized-dialog-title">
          Update Notes
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCancel}
        >
          <CloseIcon />
        </IconButton>
      </div>

      <DialogContent dividers>
        <form className='sectionalForms' onSubmit={formik.handleSubmit}>
          <div className="row">
            <div className="col-lg-12 col-sm-12">
              <div className="formdesign">
                <TextField
                  className="notesblock"
                  id="outlined-basic"
                  label="Add Notes"
                  variant="outlined"
                  size="small"
                  multiline
                  rows={6}
                  name="notes"
                  value={formik.values.notes}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.notes && Boolean(formik.errors.notes)}
                  helperText={formik.touched.notes && formik.errors.notes}
                />
              </div>
            </div>
          </div>
        </form>
      </DialogContent>

      <DialogActions>
        <div className="text-end modalactions">
          <button className='btn btn-blacked outline me-2' onClick={handleCancel}>
            Cancel
          </button>
          <button className='btn btn-blacked' onClick={formik.handleSubmit}>
            Update
          </button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateNotesModal;
